import React from "react";
import { useTranslation } from "react-i18next";
import useSocketHandlers from "../Modules/Components/useSocketHandlers";

const BackBtnLeft = () => {
    const { t } = useTranslation();
    const { backButton } = useSocketHandlers();
    return (
        <div className="main_content_backBtn">
            <div onClick={() => { backButton() }} className="back_page"  >
                <span>
                    <svg
                        viewBox="-0.5 -0.5 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        id="Round-Arrow-Left--Streamline-Solar-Ar"
                        height="30"
                        width="30"
                    >
                        <desc>Round Arrow Left Streamline Icon: https://streamlinehq.com</desc>
                        <path
                            d="M1.25 7.5a6.25 6.25 0 1 0 12.5 0 6.25 6.25 0 1 0 -12.5 0"
                            stroke-width="1"
                        ></path>
                        <path
                            d="M10 7.5H5m0 0 1.875 -1.875m-1.875 1.875 1.875 1.875"
                            stroke="#000000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                        ></path>
                    </svg>
                </span>
                <h4 className="back_btn">{t('back')}</h4>
            </div>
        </div>
    );
};

export default BackBtnLeft;
